import { render, staticRenderFns } from "./ActivityTester.vue?vue&type=template&id=8e7f24a4&scoped=true&"
import script from "./ActivityTester.vue?vue&type=script&lang=js&"
export * from "./ActivityTester.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTester.vue?vue&type=style&index=0&id=8e7f24a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7f24a4",
  null
  
)

export default component.exports